import * as React from "react";
import { SVGProps, memo } from "react";

const SvgMapPinPharmacySelected = (props: SVGProps<SVGSVGElement>) => (
  <svg width={70} height={82} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g filter="url(#MapPinPharmacySelected_svg__a)">
      <mask id="MapPinPharmacySelected_svg__b" fill="#fff">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M42.442 53.874C52.615 50.706 60 41.215 60 30 60 16.193 48.807 5 35 5S10 16.193 10 30c0 11.214 7.384 20.704 17.555 23.873l7.444 12.893 7.443-12.892Z"
        />
      </mask>

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.442 53.874C52.615 50.706 60 41.215 60 30 60 16.193 48.807 5 35 5S10 16.193 10 30c0 11.214 7.384 20.704 17.555 23.873l7.444 12.893 7.443-12.892Z"
        fill="#2BA168"
      />

      <path
        d="m42.442 53.874-.595-1.91-.746.233-.391.677 1.732 1Zm-14.887-.001 1.732-1-.39-.677-.747-.233-.595 1.91Zm7.444 12.893-1.732 1 1.732 3 1.732-3-1.732-1ZM58 30c0 10.315-6.792 19.05-16.153 21.964l1.19 3.82C54.02 52.362 62 42.115 62 30h-4ZM35 7c12.703 0 23 10.297 23 23h4C62 15.088 49.912 3 35 3v4ZM12 30C12 17.297 22.297 7 35 7V3C20.088 3 8 15.088 8 30h4Zm16.15 21.963C18.79 49.047 12 40.314 12 30H8c0 12.114 7.977 22.36 18.96 25.782l1.19-3.819Zm8.58 13.803-7.443-12.893-3.464 2 7.444 12.893 3.464-2Zm3.98-12.892-7.443 12.892 3.464 2 7.443-12.892-3.464-2Z"
        fill="#fff"
        mask="url(#MapPinPharmacySelected_svg__b)"
      />

      <path
        d="M40.114 17a7.335 7.335 0 0 0-5.223 2.163L24.664 29.391a7.34 7.34 0 0 0-2.164 5.223c0 4.072 3.314 7.386 7.386 7.386a7.333 7.333 0 0 0 5.223-2.163L45.336 29.61a7.337 7.337 0 0 0 2.164-5.224c0-4.072-3.314-7.386-7.386-7.386Zm-9.63 11.392-3.41 3.409a3.952 3.952 0 0 0-1.165 2.813.568.568 0 1 1-1.136 0c0-1.366.531-2.65 1.498-3.616l3.409-3.409a.568.568 0 1 1 .803.803Zm13.245-.39-4.712 4.712-7.23-7.232 4.711-4.712a5.078 5.078 0 0 1 3.616-1.497 5.12 5.12 0 0 1 5.113 5.113c0 1.366-.531 2.65-1.498 3.617Z"
        fill="#fff"
      />
    </g>

    <defs>
      <filter
        id="MapPinPharmacySelected_svg__a"
        x={0}
        y={0}
        width={70}
        height={81.766}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />

        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />

        <feOffset dy={5} />

        <feGaussianBlur stdDeviation={5} />

        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />

        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3421_20765" />

        <feBlend in="SourceGraphic" in2="effect1_dropShadow_3421_20765" result="shape" />
      </filter>
    </defs>
  </svg>
);

const Memo = memo(SvgMapPinPharmacySelected);

export default Memo;
